import {
    ContainerNoteType,
} from 'app/enums/label.enums'

import noteFields from './utils/note.fields'
import generalStatusFields from './utils/generalStatus.fields'
import loggerExchangeFields from './utils/loggerExchange.fields'
import locationFields from './utils/location.fields'
import getContainerStatusFields from './utils/containerStatus.fields'

function getFields({
    noteType, isNewStatusLoggerToBeExchanged, getAllowedValues,
}: {
    noteType: ContainerNoteType,
    isNewStatusLoggerToBeExchanged: boolean,
    getAllowedValues: (param: Record<string, any>) => Record<string, string>
}) {
    switch (noteType) {
    case ContainerNoteType.NOTE:
        return noteFields
    case ContainerNoteType.GENERAL_STATUS_CHANGE:
        return generalStatusFields
    case ContainerNoteType.CONTAINER_STATUS_CHANGE:
        return getContainerStatusFields({
            isNewStatusLoggerToBeExchanged, getAllowedValues,
        })
    case ContainerNoteType.LOGGER_EXCHANGE:
        return loggerExchangeFields
    case ContainerNoteType.CONTAINER_LOCATION_CHANGE:
        return locationFields
    default:
        return noteFields
    }
}

export default getFields
